import { useQuery } from "@tanstack/react-query";
import { getMarketingWholesalePromo } from "../services/wholesaleMarketingPromoService";

export const useMarketingWholesalePromo = (month = "2025-04", limit = 40) => {
  return useQuery({
    queryKey: ["wholesalepromo", month, limit],
    queryFn: () => getMarketingWholesalePromo(month, limit),
    staleTime: 1000 * 60 * 5, 
  });
};